import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tf-core-fb-basic-input-checklist-date-type',
  templateUrl: './fb-basic-input-checklist-date-type.component.html',
  styleUrls: ['./fb-basic-input-checklist-date-type.component.css']
})
export class FbCoreBasicInputChecklistDateTypeComponent implements OnInit {
    @Input()
    data: any;

    constructor() { }

    ngOnInit(): void {
        if (this.data === undefined) {
            this.data = {
                type: 'date',
                placeholder: 'DD/MM/YY'
            };
        }
    }
}
